const isSupported = (): boolean => {
    try {
        const key = '__storage_test__';
        localStorage.setItem(key, '');
        localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
};

const storage = {
    get<T = string>(key: string, fallback: T): T {
        if (!isSupported()) return fallback;

        try {
            const item = localStorage.getItem(key);
            if (item === null) return fallback;
            return JSON.parse(item) as T;
        } catch {
            return fallback;
        }
    },

    set(key: string, value: unknown): void {
        if (!isSupported()) return;

        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            if (error instanceof DOMException && error.name === 'QuotaExceededError') {
                console.error(`localStorage quota exceeded for key "${key}"`);
                return;
            }
            throw error;
        }
    },

    remove(key: string): void {
        if (!isSupported()) return;
        localStorage.removeItem(key);
    },

    has(key: string): boolean {
        if (!isSupported()) return false;
        return localStorage.getItem(key) !== null;
    },

    clear(): void {
        if (!isSupported()) return;
        localStorage.clear();
    },
};

export default storage;
